module.exports = __webpack_public_path__ + "static/media/slider-img4.3642ab2f.jpg";